import { Button, DatePicker, Form, Input, Radio, Select } from "antd";
import React, { useEffect, useState } from "react";
import { requiredField } from "../common/common";
import { UploadOutlined } from "@ant-design/icons";
import axiosInstance from "../common/api";
import { useNavigate } from "react-router";
import Dragger from "antd/lib/upload/Dragger";
import FormPage from "../common/FormPage";

export default function NewCourse() {
  const [employees, setEmployees] = useState([]);
  const [courseTypes, setCourseTypes] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const hasCertificate = Form.useWatch("hasCertificate", form);

  useEffect(() => {
    [
      { u: "courseType", f: setCourseTypes },
      { u: "employee", f: setEmployees },
    ].forEach((x) => {
      axiosInstance.get(x.u, { params: { pageSize: 99999 } }).then(({ data }) => x.f(data.data));
    });
  }, []);

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const onFormFinish = (form) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("employee", form.employee);
    formData.append("courseType", form.courseType);
    formData.append("date", form.date.format("YYYY-MM-DD"));
    ["instructor", "location", "notes"].forEach((field) => {
      if (form[field] != null) {
        formData.append(field, form[field]);
      }
    });
    formData.append("isBase", form.isBase ?? false);
    if (form.hasCertificate) {
      formData.append("certificateDate", form.certificateDate.format("YYYY-MM-DD"));
      formData.append("file", form.file.file);
    }
    axiosInstance
      .post("course", formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then(() => navigate(-1));
  };
  return (
    <FormPage
      title={"Carica nuovo corso"}
      form={form}
      onFinish={onFormFinish}
      initialValues={{ isBase: false }}
    >
      <Form.Item name="employee" label={"Dipendente"} rules={[requiredField]}>
        <Select
          filterOption={filterOption}
          showSearch
          placeholder={"Seleziona il dipendente"}
          options={employees.map((x) => ({ label: x.fullName, value: x.id }))}
        />
      </Form.Item>
      <Form.Item name="courseType" label={"Nome corso"} rules={[requiredField]}>
        <Select
          filterOption={filterOption}
          showSearch
          placeholder={"Seleziona il tipo di corso"}
          options={courseTypes.map((x) => ({ label: x.title, value: x.id }))}
        />
      </Form.Item>
      <Form.Item name="isBase" label={"Tipo di corso"}>
        <Radio.Group>
          <Radio value={true}>Base</Radio>
          <Radio value={false}>Aggiornamento</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item name="date" label={"Data"} rules={[requiredField]}>
        <DatePicker format={"DD/MM/YYYY"} style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item name="instructor" label={"Docente"}>
        <Input />
      </Form.Item>
      <Form.Item name="location" label={"Luogo"}>
        <Input />
      </Form.Item>
      <Form.Item name="notes" label={"Note"}>
        <Input.TextArea rows={3} />
      </Form.Item>
      <Form.Item name={"hasCertificate"} label={"Carica attestato"}>
        <Radio.Group>
          <Radio value={true}>Si</Radio>
          <Radio value={false}>No</Radio>
        </Radio.Group>
      </Form.Item>

      {hasCertificate && (
        <>
          <Form.Item name="certificateDate" label={"Data attestato"} rules={[requiredField]}>
            <DatePicker format={"DD/MM/YYYY"} style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label={"File"} name="file" valuePropName={"file"} rules={[requiredField]}>
            <Dragger accept={"application/pdf"} maxCount={1} beforeUpload={() => false}>
              <p>Trascina qui il file (Solo .pdf accettati)</p>
              <Button icon={<UploadOutlined />}>Seleziona file</Button>
            </Dragger>
          </Form.Item>
        </>
      )}

      <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: "end" }}>
        <Button htmlType={"submit"} type={"primary"} loading={loading}>
          Carica
        </Button>
      </Form.Item>
    </FormPage>
  );
}
